(function () {
    'use strict';

    angular
        .module('app.truck')
        .controller('TruckManagementDashboardController', TruckManagementDashboardController);

    /* @ngInject */
    function TruckManagementDashboardController(truckService, currentUser, $uibModal) {
        var vm = this;

        vm.truckSearchText = '';

        vm.page = 1;
        vm.itemsByPage = 10;
        vm.trucks = [];
        vm.request = {};
        vm.getTrucks = getTrucks;
        vm.submitRequest = submitRequest;
        vm.truck = null;

        vm.tableConfig = configureTableActions();

        vm.$onInit = function () {
        };

        function getTrucks(tableState) {

            if (tableState) {
                vm.page = tableState.pagination.start;
                vm.itemsByPage = tableState.pagination.number;
            } 
           
            return truckService.getCompanyTrucksByUserId(tableState).then(function (results) {                
                return results;                
            });
        }

        function submitRequest(truck) {

            vm.request = {
                ContactName: currentUser.name,
                ContactNumber: currentUser.number,
                ContactEmail: currentUser.email,
                NewLocation: '',
                MissingVIN: '',
                RequestType: 'Truck not available',
                RequestDetails: '',
                Truck: {
                    ShortVIN: 0
                },
                Customer: {
                    Name: '',
                    Address1: '',
                    City: '',
                    State: '',
                    StateCode: '',
                    ZipCode: '',
                    Country: '',
                    CountryCode: '',
                    LocationDisplay: ''
                }
            };

            if (truck != null) {
                vm.request.RequestType = 'Update truck location for VIN ' + truck.ShortVIN;
                vm.request.Truck.ShortVIN = truck.ShortVIN;
                vm.request.Customer.Name = truck.Customer.Name;
                vm.request.Customer.Address1 = truck.Customer.Address1;
                vm.request.Customer.City = truck.Customer.City;
                vm.request.Customer.State = truck.Customer.StateCode;
                vm.request.Customer.StateCode = truck.Customer.StateCode;
                vm.request.Customer.ZipCode = truck.Customer.ZipCode;
                vm.request.Customer.Country = truck.Customer.CountryCode;
                vm.request.Customer.CountryCode = truck.Customer.CountryCode;

                var location_full = truck.Customer.Address1 + ', ' +
                    truck.Customer.City + ', ' + truck.Customer.StateCode + ', ' +
                    truck.Customer.ZipCode + ', ' + truck.Customer.CountryCode;

                vm.request.Customer.LocationDisplay = location_full;
                vm.request.RequestDetails = 'Please relocate VIN ' +
                    truck.ShortVIN + ' for ' + truck.Customer.Name + ' from ' +
                    location_full + ' to ';

            }           

            var modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: 'app/truck/modal/request.modal.html',
                controller: 'TruckManagementModelController',
                controllerAs: 'vm',
                resolve: {
                    data: function () {
                        return vm.request;
                    }
                }
            });

            modalInstance.result.then(function () {
                //alert("now I'll close the modal");
                console.log(vm.request);
            });
        }

        function configureTableActions() {
            var tableConfig = truckService.getTableConfig();
            tableConfig.actions = [
                {
                    name: '"Report Invalid Location"',
                    action: submitRequest,
                    icon: '"fa-pencil"',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin', 'SSO:Site:Admin']
                }
            ];
            return tableConfig;
        }
    }
})();
